import React from "react";
import { withRouter } from "react-router-dom";

import moment from "moment";

import { Modal, Popover, OverlayTrigger, Dropdown, MenuItem, ButtonToolbar, Button as BsButton } from "react-bootstrap";
import { toast } from "react-toastify";

import Slider from "rc-slider";
import { defineGrid, extendHex } from "honeycomb-grid";

import { ScrollSync, ScrollSyncPane } from "react-scroll-sync";

import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagic,
  faDatabase,
  faChartBar,
  faList,
  faDotCircle,
  faCircle,
  faMapMarker,
  faPlay,
  faPause,
  faFastForward,
  faTh,
  faEdit,
  faComments,
  faThumbsUp,
  faThumbsDown,
  faTrash,
  faUsers,
  faTimes
} from "@fortawesome/free-solid-svg-icons";

import { Button, ButtonGroup } from "aible";
import { LineInput } from "components/Inputs/LineInput";
import { SetupText } from "components/Next/Models/Models";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import NextChartContainer from "components/Next/Charts/NextChart";
import CommentModalContainer from "containers/Next/Comments/CommentModal";

import styles from "./style.module.css";

export default class ExploreTask extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getInitialsFromText(text) {
    if (text === undefined) {
      return undefined;
    }

    const matches = text.match(/\b(\w)/g);
    return matches.join("").substring(0, 3);
  }

  renderComment(comment, index) {
    const { editComment, editFeedback, deleteFeedback, task } = this.props;

    return (
      <div
        key={index}
        className={styles.comment}
        style={index % 2 === 0 ? { background: "rgba(236, 236, 252, 1)" } : {}}
      >
        <div className={styles.commentStatus}>
          <div className={styles.assignCircle}>{this.getInitialsFromText(comment?.created_by?.fullname)}</div>
          <div>{comment?.created_by?.fullname}</div>
          <div
            className={styles.commentDate}
            title={moment.utc(comment?.created_date).local().format("MMMM Do YYYY, h:mm:ss a")}
          >
            {moment.utc(comment?.created_date).local().fromNow()}
          </div>
        </div>
        <div className={styles.commentText}>{comment?.message}</div>
        <div className={styles.commentButtons}></div>
      </div>
    );
  }

  renderComments() {
    const { exploreComments, exploreAssign, updateIsComment, task } = this.props;

    let combined = task?.comments || [];

    return (
      <React.Fragment>
        <div className={styles.commentHeader}>
          <FontAwesomeIcon icon={faComments} style={{ marginRight: "10px" }} />
          {"Comments and Feedback"}
        </div>
        <div className={styles.commentList}>
          {combined.length === 0 ? (
            <div className={styles.emptyComments}>{"No Comments or Feedback found"}</div>
          ) : (
            <div>
              {combined
                .sort((a, b) =>
                  moment(a.created_date).isBefore(moment(b.created_date))
                    ? 1
                    : moment(b.created_date).isBefore(moment(a.created_date))
                      ? -1
                      : 0
                )
                .map((c, i) => this.renderComment(c, i))}
            </div>
          )}
        </div>
        <div className={styles.newComment}>
          <CommentModalContainer id={task?.id} nextId={task?.nextId} isNoModal task={task} />
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { taskId, task, dataset, datasetId, hasNext, projectId, optimized, isLoadingProject, isExploreReady } =
      this.props;

    const isLoading =
      isLoadingProject || dataset === undefined || (dataset?.fields && dataset?.outcome && isExploreReady);

    const metadata = task?.versions?.[0]?.data?.metadata;
    const nextId = task?.versions?.[0]?.data?.nextId;

    return (
      <div className={styles.exploreTask}>
        {isLoading === true ? (
          <div className={styles.loading}>
            {"Loading Task..."}
            <LoadingIndicator
              style={{
                margin: "0px",
                marginTop: "70px",
                transform: "scale(2)"
              }}
            />
          </div>
        ) : (
          <div className={styles.nextChart}>
            <NextChartContainer
              id={nextId}
              datasetId={datasetId}
              chart={{ metadata: metadata }}
              isExploreTask={true}
              showTooltip={true}
              showLeakage={true}
            />
          </div>
        )}
        <div className={styles.commentPanel}>{this.renderComments()}</div>
      </div>
    );
  }
}
